import { Fragment, ReactNode } from "react";
import { connect, MapDispatchToProps, MapStateToProps, MergeProps } from "react-redux";

import { ControlsKey, createControlsValueChangedAction, getRawValue } from "@multiweb/reactControls";
import { IAppState } from "@multiweb/types/react";
import { ControlReduxRawValue } from "../../controls/types";

type ControlValueWrapperChildrenProps = {
    rawValue: ControlReduxRawValue;
    onChange: (rawValue: ControlReduxRawValue) => void;
};

export type ControlValueWrapperProps = {
    dataKey: ControlsKey;
    /** Control, který je předmětem napojení hodnoty na redux. */
    children: (props: ControlValueWrapperChildrenProps) => ReactNode;
};

type StateProps = {
    rawValue: ControlReduxRawValue;
};

const mapStateToProps: MapStateToProps<StateProps, ControlValueWrapperProps, IAppState> = (state, { dataKey }) => ({
    rawValue: getRawValue(state, dataKey),
});

type DispatchProps = {
    onChange: (rawValue: ControlReduxRawValue) => void;
};

const mapDisptachToProps: MapDispatchToProps<DispatchProps, ControlValueWrapperProps> = (dispatch, { dataKey }) => ({
    onChange: (rawValue) => dispatch(createControlsValueChangedAction(dataKey, rawValue)),
});

export type ControlValueWrapperComponentProps = {
    rawValue: ControlReduxRawValue;
    onChange: (rawValue: ControlReduxRawValue) => void;
    /** Control, který je předmětem napojení hodnoty na redux. */
    children: (props: ControlValueWrapperChildrenProps) => ReactNode;
};

const mergeProps: MergeProps<StateProps, DispatchProps, ControlValueWrapperProps, {children: ReactNode}> = ({ rawValue }, { onChange }, { children }) => ({
    children: children({ rawValue, onChange }),
});

/**
 * Obálka nad control napojující jeho hodnotu na redux.
 */
export const ControlValueWrapper = connect(mapStateToProps, mapDisptachToProps, mergeProps)(Fragment);
